import { render, staticRenderFns } from "./MoveModal.vue?vue&type=template&id=1b4554ec&scoped=true"
import script from "./MoveModal.vue?vue&type=script&lang=js"
export * from "./MoveModal.vue?vue&type=script&lang=js"
import style0 from "./MoveModal.vue?vue&type=style&index=0&id=1b4554ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4554ec",
  null
  
)

export default component.exports